import { SelectUser } from "./selectUser";

export class CurrentUser extends SelectUser{
    isSuperAdmin: boolean = false;
    isAuthorized: boolean = false;
}